import React, { useReducer, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../css/enrollment.css";
import { getError } from "../../../../utils";

const reducer = (state, action) => {
  switch (action.type) {
    case "CREATE_REQUEST":
      return { ...state, loadingCreate: false };
    case "CREATE_SUCCESS":
      return {
        ...state,
        loadingCreate: false,
      };
    case "CREATE_FAIL":
      return { ...state, loadingCreate: false };

    default:
      return state;
  }
};

const Enrollment = ({ onSuccess, notes, subject }) => {
  const [{ loadingCreate }, dispatch] = useReducer(reducer, {
    loadingCreate: false,
    error: "",
  });

  const MIN_MESSAGE_LENGTH = 10;

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: subject || "",
    message: notes || "",
  });
  const [minMessage, setMinMessage] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState(false);
  const [subjectTest, setSubjectTest] = useState(false);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async e => {
    e.preventDefault();

    const regex = /^(0|\+84)[3|5|7|8|9][0-9]{8}$/;
    if (!regex.test(formData.phone)) {
      setPhoneNumber(true);
      return;
    }

    if (formData.subject.length < 3) {
      setSubjectTest(true);
      return;
    }

    if (formData.message.length <= MIN_MESSAGE_LENGTH) {
      setMinMessage(true);
      return;
    }

    try {
      dispatch({ type: "CREATE_REQUEST" });
      const result = await axios.post("/contact/create", formData);
      toast.success(result.data.message);
      dispatch({ type: "CREATE_SUCCESS" });
      setFormData({
        name: "",
        phone: "",
        email: "",
        subject: "",
        message: "",
      });
      setMinMessage(false);
      setPhoneNumber(false);
      setSubjectTest(false);
      onSuccess && onSuccess();
    } catch (err) {
      toast.error(getError(err) || "Đã xảy ra lỗi!");
      dispatch({
        type: "CREATE_FAIL",
      });
    }
  };

  return (
    <form className="enrollment-form" onSubmit={handleSubmit}>
      <div className="row step-1">
        <div className="col-12 text-center">
          <h2 className="text-center box-title">
            HÂN HẠNH ĐƯỢC HỖ TRỢ QUÝ KHÁCH
          </h2>
          <p className="  mb-4 intro">
            Quý khách vui lòng điền thông tin bên dưới và gửi. Chúng tôi sẽ tiếp
            nhận và liên hệ lại trong thời gian sớm nhất.
          </p>
        </div>
        <div className="col-md-6">
          <input
            name="name"
            type="text"
            className="form-control mb-3"
            placeholder="Họ và tên"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-6 mb-3">
          <input
            name="phone"
            type="text"
            className="form-control mb-1"
            placeholder="Điện thoại"
            value={formData.phone}
            onChange={handleChange}
            required
          />
          {phoneNumber && (
            <p className="text-danger message-text">
              Số điện thoại không hợp lệ!
            </p>
          )}
        </div>
        <div className="col-md-6">
          <input
            name="email"
            type="email"
            className="form-control mb-3"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>
        <div className="col-md-6 mb-3">
          <input
            name="subject"
            type="text"
            className="form-control mb-1"
            placeholder="Tiêu đề"
            value={formData.subject}
            onChange={handleChange}
            required
          />
          {subjectTest && (
            <p className="text-danger message-text">Chủ đề ít nhất 3 ký tự!</p>
          )}
        </div>
        <div className="col-md-12">
          <textarea
            name="message"
            className="form-control mb-1"
            placeholder="Nội dung"
            value={formData.message}
            onChange={handleChange}
            required
          />
          {minMessage && (
            <p className="text-danger message-text">
              Nội dung phải có ít nhất {MIN_MESSAGE_LENGTH} ký tự!
            </p>
          )}
        </div>

        <div className="btnSuccess col-12 text-center">
          <button type="submit" className="btn button" disabled={loadingCreate}>
            {loadingCreate ? "Đang gửi..." : "Gửi"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default Enrollment;
